import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { Dates } from '../../utils/calendar-utils';
import {
  V3SimpleProductAvailability,
  V3TeacherColLessonScheduleEvents,
} from '../../../model/v3/booking';

@Injectable({
  providedIn: 'root',
})
export class TeacherBookRestServiceV3 {
  constructor(private http: HttpClient) {}

  private buildUrl(schoolId: number, teacherId: number): string {
    return `${environment.eventsApiBase}/v1/schools/${schoolId}/teachers/${teacherId}/schedule-events`;
  }

  public getAvailabilityEvents(
    schoolId: number,
    teacherId: number,
    dateFrom?: Date | null,
    dateTo?: Date | null,
    productCode?: string | null
  ): Observable<V3SimpleProductAvailability[]> {
    return this.http
      .get<V3SimpleProductAvailability[]>(this.buildUrl(schoolId, teacherId), {
        params: this.buildEventsParams('availability', dateFrom, dateTo, productCode),
      })
      .pipe(
        tap((schedules) =>
          schedules.forEach((schedule) =>
            schedule.events.forEach(
              (ev) => (ev.eventDate = Dates.parse(String(ev.eventDate)))
            )
          )
        ),
        map((worktimes) => worktimes ?? [])
      );
  }

  public getTeacherColLessonEvents(
    schoolId: number,
    teacherId: number,
    dateFrom?: Date | null,
    dateTo?: Date | null
  ): Observable<V3TeacherColLessonScheduleEvents[]> {
    return this.http
      .get<V3TeacherColLessonScheduleEvents[]>(this.buildUrl(schoolId, teacherId), {
        params: this.buildEventsParams('col_lesson', dateFrom, dateTo),
      })
      .pipe(
        tap((schedules) =>
          schedules.forEach((schedule) =>
            schedule.events.forEach(
              (ev) => (ev.eventDate = Dates.parse(String(ev.eventDate)))
            )
          )
        ),
        map((schedules) => schedules ?? [])
      );
  }

  private buildEventsParams(
    type: 'availability' | 'col_lesson',
    dateFrom?: Date | null,
    dateTo?: Date | null,
    productCode?: string | null
  ): { [param: string]: string } {
    const params: { [param: string]: string } = { type };
    if (dateFrom) params.dateFrom = dateFrom.toISOString();
    if (dateTo) params.dateTo = dateTo.toISOString();
    if (productCode) params.productCode = productCode;
    return params;
  }
}
